var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.81836 4.55555V23.2222C2.87234 24.2494 3.63654 25 4.63654 25L17.3638 25C18.3678 25 19.1178 24.2494 19.182 23.2222V4.55555",
    stroke: "#EB4D4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.55555H21H1Z",
    fill: "#EB4D4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.55555H21",
    stroke: "#EB4D4B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36324 4.55556V2.33334C7.36271 2.1581 7.39763 1.98449 7.46597 1.82249C7.53431 1.66049 7.63474 1.5133 7.76147 1.38939C7.8882 1.26547 8.03873 1.16728 8.20441 1.10045C8.37009 1.03363 8.54765 0.999492 8.72687 1.00001H13.2723C13.4516 0.999492 13.6291 1.03363 13.7948 1.10045C13.9605 1.16728 14.111 1.26547 14.2377 1.38939C14.3645 1.5133 14.4649 1.66049 14.5332 1.82249C14.6016 1.98449 14.6365 2.1581 14.636 2.33334V4.55556M10.9996 8.11112V20.5556M6.90869 8.11112V20.5556M15.0905 8.11112V20.5556",
    stroke: "#EB4D4B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.19d90bfcd5c5359e32cb6c388aa838ae.svg";
export { ForwardRef as ReactComponent };